/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "If props.children exist the ModalHeader ignores the properties 'label', 'icon' and 'onClose' and renders whatever children are passed to it inside the 'header' tag. Since the properties 'background' and 'extraClasses' are used to style the 'header' tag, they still apply."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to ModalHeader."
    },
    {
        name: "label",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The label of the header."
    },
    {
        name: "icon",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The class name of an icon to be shown left of the header label."
    },
    {
        name: "background",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true shows the modal header with a darker background."
    },
    {
        name: "onClose",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A callback function to be invoked when the close icon in the header is clicked. Defined by parent. Cannot be overridden on header level."
    },
    {
        name: "hideCloseIcon",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: 'If set to true will hide the "x" close icon in the header.'
    }
];

export default documentedProperties;
